<form #childForm="ngForm">
  <section [class.filled]="selectedMonth">
    <label for="month">
      {{ 'onboarding.personal-data.month' | translate: { Default: 'Mes' } }}
    </label>
    <select id="month" name="month" [(ngModel)]="selectedMonth" #month="ngModel"
            (ngModelChange)="updateDaysInMonth(); onFormChange()" required>
      <option [ngValue]="null" disabled selected>
        {{ 'onboarding.personal-data.month' | translate: { Default: 'Mes' } }}
      </option>
      <option *ngFor="let month of monthsRange; let i = index" [value]="i + 1">
        {{ ('onboarding.personal-data.monthList.' + (i + 1)) | translate }}
      </option>
    </select>
  </section>

  <section [class.filled]="selectedDay">
    <select id="day" name="day" [(ngModel)]="selectedDay" #day="ngModel"
            (ngModelChange)="emitDateChange(); onFormChange()" required>
      <option [ngValue]="null" disabled selected>
        {{ 'onboarding.personal-data.day' | translate: { Default: 'Día' } }}
      </option>
      <option *ngFor="let day of daysInMonth" [value]="day">
        {{ day }}
      </option>
    </select>
  </section>

  <section [class.filled]="selectedYear">
    <label for="year">
      {{ 'onboarding.personal-data.year' | translate: { Default: 'Año' } }}
    </label>
    <select id="year" name="year" [(ngModel)]="selectedYear" #year="ngModel"
            (ngModelChange)="updateDaysInMonth(); onFormChange()" required>
      <option [ngValue]="null" disabled selected>
        {{ 'onboarding.personal-data.year' | translate: { Default: 'Año' } }}
      </option>
      <option *ngFor="let year of yearRange" [value]="year">
        {{ year }}
      </option>
    </select>
  </section>
</form>
